
import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Simple error fallback
function showError() {
  const rootElement = document.getElementById('root')
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; flex-direction: column; font-family: system-ui, -apple-system, sans-serif; text-align: center; padding: 20px; background: white;">
        <h1 style="color: #0f766e; margin-bottom: 16px; font-size: 2rem;">Equilibrada🧠Mente™</h1>
        <p style="color: #666; margin-bottom: 24px; font-size: 1.1rem;">
          Estamos com problemas técnicos temporários.
        </p>
        <button onclick="window.location.reload()" style="background-color: #0f766e; color: white; padding: 12px 24px; border: none; border-radius: 8px; cursor: pointer; font-size: 16px; margin: 8px;">
          Tentar novamente
        </button>
        <div style="margin-top: 24px;">
          <p style="color: #666; font-size: 14px; margin-bottom: 8px;">
            Ou entre em contato via WhatsApp:
          </p>
          <a href="https://wa.me/5521994740504?text=Olá, quero equilibrar minha mente agora" style="color: #0f766e; text-decoration: none; font-weight: bold; font-size: 1.1rem;">
            (21) 99474-0504
          </a>
        </div>
      </div>
    `
  }
}

try {
  const rootElement = document.getElementById('root')
  if (!rootElement) {
    throw new Error('Root element not found')
  }

  // Hide loading screen
  const loading = document.getElementById('loading')
  if (loading) {
    loading.style.display = 'none'
  }

  const root = createRoot(rootElement)
  
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  )
  
} catch (error) {
  console.error('Erro ao inicializar:', error)
  showError()
}

// Global error handlers
window.addEventListener('error', function(e) {
  console.error('Erro global:', e.error)
  showError()
})

window.addEventListener('unhandledrejection', function(e) {
  console.error('Promise rejeitada:', e.reason)
  showError()
})
